
  

<div class="grid">
	<div class="col-12">
		<div class="card cardbig">
			<p-table #maintable [value]="opportunitiesData" 
				dataKey="id" 
				[paginator]="true" 
				[rows]="20" 
				showGridlines 
				[loading]="isLoaded"
				[resizableColumns]="true"
				columnResizeMode="expand"
				[tableStyle]="{ 'min-width': '60rem' }" 
				[globalFilterFields]="['account_name', 'numero','num_opp','name','assigned_to_name','status']"
				>
				<ng-template pTemplate="caption">
					<div class="grid">
						<div class="col-2 pt-2 "><br>
							<button pButton label="{{lang.el('Nuovo preventivo')}}" 
								class="p-button-outlined mb-2" icon="pi pi-plus" (click)="nuovoPreventivo()">
							</button>
						</div>
                        <div class="p-col-2 pt-2 pl-2">
							<label>{{lang.el('Dalla data')}}</label><br>
                              <p-calendar 
                                  [(ngModel)]="from_date" 
                                  dateFormat="dd/mm/yy" 
                                  [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}" appendTo="body" >
                              </p-calendar>
                        </div>
                        <div class="p-col-2 pt-2 pl-2">
							  <label>{{lang.el('Alla data')}}</label><br>
                              <p-calendar 
                                  [(ngModel)]="to_date" 
                                  dateFormat="dd/mm/yy" 
                                  [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}" appendTo="body" >
                              </p-calendar>
                        </div>
						<div class="col-2 pt-2 "><br>
							<button pButton label="{{lang.el('Aggiorna')}}" 
								class="p-button-outlined mb-2" (click)="load()">
							</button>
						</div>
						<div class="col-1" style="text-align:right;"><br>
						</div>
						<div class="col-1" style="text-align:right;"><br>
						</div>
						<div class="col-2" style="text-align:right;"><br>
 							<span class="p-input-icon-left mb-4 ml-2">
                                <i class="pi pi-search"></i>
                                <input pInputText type="text" #filter (input)="onGlobalFilter(maintable, $event)" 
                                placeholder="{{lang.el('Ricerca')}}" class="w-full"/>
                            </span>
						</div>
						
					</div>
				</ng-template>
				<ng-template pTemplate="header">
					<tr>
					
						<th style="width: 5rem"></th>
						<th style="width: 5rem"></th>
						<th pResizableColumn pSortableColumn="numero">{{lang.el('ID')}}<p-sortIcon field="numero" /></th>
						<th pResizableColumn pSortableColumn="num_opp">{{lang.el('Numero')}}<p-sortIcon field="num_opp" /></th>
						<th pResizableColumn pSortableColumn="account_name">{{lang.el('Cliente')}}<p-sortIcon field="account_name" /></th>
						<th pResizableColumn pSortableColumn="account_code">{{lang.el('Codice cliente')}}<p-sortIcon field="account_code" /></th>
						<th style="min-width: 12rem" pResizableColumn pSortableColumn="name">{{lang.el('Descrizione')}}<p-sortIcon field="name" /></th>
						<th pResizableColumn pSortableColumn="assigned_to_name">{{lang.el('Assegnato a')}} <p-sortIcon field="assigned_to_name" /></th>
						<th pResizableColumn pSortableColumn="status">{{lang.el('Stato')}} <p-sortIcon field="status" /></th>
						<th pResizableColumn pSortableColumn="exp_closing_date">{{lang.el('Data')}} <p-sortIcon field="exp_closing_date" /></th>
						<th pResizableColumn pSortableColumn="amount">{{lang.el('Importo')}} <p-sortIcon field="amount" /></th>
					</tr>
					<tr>
						<th style="width: 5rem"></th>
						<th style="width: 5rem"></th>
						<th>
							<p-columnFilter 
								type="text" 
								field="numero"/>
						</th>
						<th>
							<p-columnFilter 
								type="text" 
								field="num_opp"/>
						</th>
						<th>
							<p-columnFilter 
								type="text" 
								field="account_name"/>
						</th>
						<th>
							<p-columnFilter 
								type="text" 
								field="account_code"/>
						</th>
						<th>
							<p-columnFilter 
								type="text" 
								field="name"/>
						</th>
						<th>
							<p-columnFilter 
								type="text" 
								field="assigned_to_name"/>
						</th>
						<th>
							<p-columnFilter field="status" matchMode="equals" [showMenu]="false">
								<ng-template pTemplate="filter" let-value let-filter="filterCallback">
									<p-dropdown 
										[ngModel]="value" 
										appendTo="body"
										[style]="{'width':'100%'}"
										[options]="statusCellaOptions" 
										(onChange)="filter($event.value)" 
										[showClear]="true">
									</p-dropdown>
								</ng-template>
							</p-columnFilter>
						</th>
						<th></th>
						<th></th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-opp>
					<tr>
					
						<td>
							<button pButton pRipple icon="pi pi-pencil" 
							class="p-button-rounded p-button-text" (click)="editPrev(opp)"></button>
						</td>
						<td>
							<button pButton pRipple icon="pi pi-copy" title="Duplica"
							class="p-button-rounded p-button-text" (click)="duplicate(opp)"></button>
						</td>
						<td>{{ opp.numero }}</td>
						<td>{{ opp.num_opp }}</td>
						<td>{{ opp.account_name }}</td>
						<td>{{ opp.account_code }}</td>
						<td>{{ opp.name }}</td>
						<td>{{ opp.assigned_to_name }}</td>
						<td>{{lang.el(opp.status)}}</td>
						<td>{{ opp.exp_closing_date }}</td>
						<td>{{ opp.amount | currency : 'EUR' }}</td>
						<td>
							<button pButton pRipple icon="pi pi-trash" 
								class="p-button-rounded p-button-text" (click)="deleteOpp(opp)"></button>
						</td>
					</tr>
				</ng-template>
					
			</p-table>
		</div>
	</div>

  
  
    <p-toast />

    <p-confirmDialog  [acceptButtonStyleClass]="'p-button-text'"
    [rejectButtonStyleClass]="'p-button-text p-button-danger'"></p-confirmDialog>
	